<app-navbar-container breadcrumb="Audit">
  <app-navbar-item-large [link]="'/' + Routes.AuditLog" title="Audit-Protokoll">
    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 12l2 2 4-4m-3-7.747a4 4 0 0 1-3.4 1.347 4 4 0 0 0-3.4 1.347A4 4 0 0 1 3.853 8.6a4 4 0 0 0-.001 4.8A4 4 0 0 1 5.2 16.8a4 4 0 0 0 1.347 3.4A4 4 0 0 1 9.6 21.547a4 4 0 0 0 4.8 0 4 4 0 0 1 3.053-1.347 4 4 0 0 0 1.347-3.4 4 4 0 0 1 1.347-3.4 4 4 0 0 0 0-4.8 4 4 0 0 1-1.347-3.4 4 4 0 0 0-1.347-3.4 4 4 0 0 1-3.053-1.347 4 4 0 0 0-4.8 0z"
            stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"/>
    </svg>
  </app-navbar-item-large>
</app-navbar-container>
